import { HeroIcon } from '@components/HeroIcon'
import { Modal } from '@components/Modal'
import { useIsMobile } from '@hooks/useIsMobile'
import { useTranslation } from 'react-i18next'
import { Dialog, Text, XStack, YStack } from 'tamagui'
import { useBrand } from '@hooks/useBrand'

interface IPaymentRefundBankSlipModalProps {
  onClose: () => void
  open: boolean
}

export function PaymentRefundBankSlipModal({
  onClose,
  open,
}: IPaymentRefundBankSlipModalProps) {
  const { t } = useTranslation('OrderDetails')
  const brand = useBrand()
  const email = brand.paymentsEmail

  const isMobile = useIsMobile()

  const handleOpenEmail = () => {
    window.open(`mailto:${email}`, '_blank')
  }

  return (
    <Modal
      onClose={onClose}
      open={open}
      snapPoints={isMobile ? [370, 190] : [60, 100]}
      snapPointsMode={isMobile ? 'constant' : 'percent'}
      position={isMobile ? 0 : undefined}
      backdropOpacity={0.9}
      maxWidth={392}
      dismissOnSnapToBottom={isMobile}
      shouldAdapt={isMobile}
    >
      <YStack
        padding="$size.spacing-lg"
        $gtSm={{
          p: '$size.spacing-lg',
          width: 392,
        }}
        height={isMobile ? 'auto' : '100%'}
        justifyContent="flex-start"
        alignItems="center"
      >
        <YStack alignItems="center" width="100%" maxWidth={400}>
          <HeroIcon
            icon={['fal', 'circle-exclamation']}
            color="$danger-100"
            size={48}
          />
          <Dialog.Title
            color="$text-primary"
            ff="$mulishBold"
            fontSize="$font-size-sm"
            lineHeight={25}
            textAlign="center"
            whiteSpace="pre-line"
            marginTop="$size.spacing-sm"
            $gtSm={{
              paddingHorizontal: 20,
            }}
          >
            {t('refundBankSlip.title')}
          </Dialog.Title>
          <Dialog.Description
            color="$text-primary"
            fontFamily="$mulishRegular"
            fontSize="$font-size-xxs"
            textAlign="center"
            whiteSpace="pre-line"
            marginTop="$size.spacing-xxxs"
            lineHeight={21}
          >
            {t('refundBankSlip.description')}
            {'\n'}
            <Text
              color="$accent"
              fontFamily="$mulishRegular"
              fontSize="$font-size-xxs"
              textDecorationLine="underline"
              onPress={handleOpenEmail}
            >
              {email}
            </Text>{' '}
            {t('refundBankSlip.descriptionPart2')}
          </Dialog.Description>

          <YStack
            backgroundColor="$bg-surface-raised"
            paddingVertical="$size.spacing-xxxs"
            paddingHorizontal="$size.spacing-md"
            borderRadius="$border-radius-md"
            marginTop="$size.spacing-xs"
            marginBottom="$size.spacing-lg"
            gap="$size.spacing-nano"
            alignSelf="stretch"
          >
            <Text
              color="$text-primary"
              fontFamily="$mulishRegular"
              fontSize="$font-size-xxxs"
              textAlign="left"
              whiteSpace="pre-line"
              lineHeight={18}
            >
              {t('refundBankSlip.bankSlipData')}
            </Text>
          </YStack>

          <XStack
            justifyContent="center"
            alignItems="center"
            width="100%"
            marginTop="$size.spacing-xs"
          >
            <Text
              color="$accent"
              fontFamily="$mulishRegular"
              fontSize="$font-size-xs"
              textDecorationLine="underline"
              onPress={onClose}
              textAlign="center"
            >
              {t('refundError.closeButton')}
            </Text>
          </XStack>
        </YStack>
      </YStack>
    </Modal>
  )
}
